import { ApiError, storeAPIerror } from '../utils/apiErrorFeedback';
import * as R from 'ramda';
import { Actions as EdgeDeviceActions } from '../actions/edge_devices';

export type EdgeDeviceState = {
  edgeConfigFileBySerialNumber: EdgeConfigFileBySerialNumber;
};

export type EdgeConfigFileBySerialNumber = {
  [serialNumber: string]: EdgeConfigFile;
};

export type EdgeConfigFile = {
  configYaml: string;
  id: number;
  serialNumber: string;
  uuid: string;
  lastRunningConfigHash: string;
  lastSentConfigHash: string;
  currentConfigHash: string;
  yamlValidationErrors: [];
};

const initialState: EdgeDeviceState = {
  edgeConfigFileBySerialNumber: {},
};

const edgeDevices = (state = initialState as EdgeDeviceState, action: any) => {
  switch (action.type) {
    case EdgeDeviceActions.GET_EDGE_CONFIG_FILE_SUCCESS: {
      return R.pipe(
        R.assocPath(
          ['edgeConfigFileBySerialNumber', action.serialNumber],
          action.payload
        )
      )(state);
    }

    case EdgeDeviceActions.GET_EDGE_CONFIG_FILE_LOADING: {
      return R.pipe(
        R.assocPath(
          ['edgeConfigFileBySerialNumber', action.serialNumber, 'isLoading'],
          true
        )
      )(state);
    }

    case EdgeDeviceActions.GET_EDGE_CONFIG_FILE_ERROR: {
      return R.pipe(
        R.assocPath(['edgeConfigFileBySerialNumber', action.serialNumber], {
          isLoading: false,
          data: {},
          apiError: storeAPIerror(action),
        })
      )(state);
    }

    default:
      return state;
  }
};

export default edgeDevices;
